<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Cấu hình Form Email thông báo</h2>
      </div>
    </el-row>

    <el-row>
      <div class="model-body">
        <el-row type="flex" class="row-bg" :gutter="24">
          <el-col :gutter="24">
            <el-col :span="16">
              <el-collapse v-model="activeNames">
                <el-collapse-item name="0">
                  <template slot="title">
                    <h3 class="title ml-2" v-if="updateTargetId">Sửa Form thông báo</h3>
                    <h3 class="title ml-2" v-else>Thêm mới Form thông báo</h3>
                  </template>
                  <div class="demo-block">
                    <div class="source">
                      <el-form :model="form" :rules="rules" label-width="120px" ref="createModel" @submit.native.prevent>
                        <el-form-item prop="title" label="Tiêu đề" class="form-item">
                          <el-input v-model="form.title" placeholder="Tiêu đề thông báo" class="input-seach" clearable></el-input>
                        </el-form-item>

                        <el-form-item prop="category_noti_id" label="Kiểu thông báo" class="form-item">
                          <el-select v-model="form.category_noti_id" filterable placeholder="Chọn kiểu thông báo" class="input-select">
                            <el-option v-for="item in lists.listNotis" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item prop="content" label="Nội dung" class="form-item">
                          <el-input v-model="form.content" :rows="11" type="textarea" class="input-seach"></el-input>
                        </el-form-item>
                        <el-form-item prop="to_addr" label="Mail To" class="form-item">
                          <el-input v-model="form.to_addr" class="input-seach"
                            placeholder="Nhập dưới dạng email1@email.com, email2@email.com, email3@email.com,..."
                            clearable
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="Mail CC" class="form-item">
                          <el-input v-model="form.cc_addr" class="input-seach"
                          placeholder="Nhập dưới dạng email1@email.com, email2@email.com, email3@email.com,..."
                          clearable></el-input>
                        </el-form-item>
                        <el-form-item label="Mail BCC" class="form-item">
                          <el-input v-model="form.bcc_addr" class="input-seach"
                          placeholder="Nhập dưới dạng email1@email.com, email2@email.com, email3@email.com,..."
                          clearable></el-input>
                        </el-form-item>
                        <el-form-item label="Trạng thái" class="form-item">
                          <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" @click="submitForm('createModel')" size="small" plain :disable="!canSubmit" :loading="!canSubmit">
                            <i class="fa fa-save"></i> Lưu lại
                          </el-button>
                          <el-button type="warning" @click="reloadForm()" size="small" plain :disable="!canSubmit" :loading="!canSubmit">
                            <i class="fas fa-redo"></i> Hoàn tác
                          </el-button>
                          <el-button type="primary" @click="sendMailTest()" size="small">Test mail</el-button>
                        </el-form-item>

                      </el-form>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-col>
            <el-col :span="24">
              <h3>Danh sách</h3>
            </el-col>
            <el-col :span="24">
                <div class="model-pagination">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size="table.pagination.per_page"
                    :pager-count="table.pagination.count"
                    :current-page="table.pagination.current_page"
                    :total="table.pagination.total"
                    @current-change="changeCurrentPage">
                  </el-pagination>
                  <div style="padding-left: 5px">
                    Hiển thị tới Form thông báo số <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Form thông báo
                  </div>
                </div>
            </el-col>
              <el-col :span="24">
                <div class="model-table">
                  <el-table v-loading="loading" :data="table.database" style="width: 100%">
                    <el-table-column type="index" indexlabel="No." width="30">
                    </el-table-column>
                    <el-table-column prop="title" label="Tiêu đề" width="150">
                    </el-table-column>
                    <el-table-column prop="content" label="Nội dung" width="220">
                    </el-table-column>
                    <el-table-column prop="category_noti_name" label="Loại" width="150">
                    </el-table-column>
                    <el-table-column prop="to_addr" label="Mail to" width="150">
                    </el-table-column>
                    <el-table-column prop="cc_addr" label="Mail CC" width="150">
                    </el-table-column>
                    <el-table-column prop="bcc_addr" label="Mail BCC" width="150">
                    </el-table-column>
                    <el-table-column prop="status" label="Trạng thái" width="80">
                      <template slot-scope="scope">
                        <el-switch
                          v-model="scope.row.status"
                          active-color="#13ce66"
                          inactive-color="#7f8c8d"
                          @change="changeStatus(scope.row)">
                        </el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column label="Hành động" width="130">
                      <template slot-scope="scope">
                        <el-row>
                          <el-button @click="updateModel(scope.row)" size="small" type="primary" :edit-id="scope.row.id" icon="el-icon-edit"
                            circle plain></el-button>
                          <el-button @click="confirmDeleteModel(scope.row)" size="small" type="danger" :delete-id="scope.row.id" icon="el-icon-delete"
                            circle plain></el-button>
                        </el-row>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
          </el-col>

        </el-row>

      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'FormNotis',
  metaInfo () {
    return {
      title: 'Cấu hình Form thông báo'
    }
  },
  data() {
    return {
      activeNames: ['0'],
      canSubmit: true,
      loading: false,
      updateTargetId: 0,
      form: {
        title: '',
        category_noti_id: null,
        content: '',
        to_addr: '',
        cc_addr: '',
        bcc_addr: '',
        status: true,
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      },
      lists: {
        listNotis: [],
      },
      rules: {
        title: [
          { required: true, message: 'Vui lòng nhập tiêu đề thông báo' },
          { min: 2, max: 191, message: 'Tiêu đề thông báo có chiều dài từ 2 tới 191 kí tự' }
        ],
        category_noti_id: [
          { required: true, message: 'Vui lòng chọn kiểu thông báo' }
        ],
        content: [
          { required: true, message: 'Vui lòng nhập nội dung thông báo' }
        ],
        to_addr: [
          { required: true, message: 'Vui lòng nhập địa chỉ email muốn gửi tới' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchCategoriNotis()
    this.fetchDatabaseModel ()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'form-notis', text: 'Cấu hình Form thông báo' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    fetchCategoriNotis () {
      axios.get('category-notis', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listNotis = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('form-notis', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    sendMailTest () {
      axios.post('form-notis-send-mail-test').then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Gửi thông báo thành công',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.put('category-notis/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })

    },
    storeModel () {
      this.canSubmit = false

      if (this.updateTargetId && this.updateTargetId != 0) {
        axios.put('form-notis/' + this.updateTargetId, this.form).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Cập nhật Form thông báo thành công',
                type: 'success'
              })
              this.form.name = ''
              this.fetchDatabaseModel()
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      }
      else {
        axios.post('form-notis', this.form).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Thêm Form thông báo thành công',
                type: 'success'
              })

              this.form.name = ''
              this.fetchDatabaseModel()
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      }
    },
    reloadForm () {
      this.updateTargetId = 0
      this.form.title = ''
      this.form.category_noti_id = null
      this.form.content = ''
      this.form.to_addr = ''
      this.form.cc_addr = ''
      this.form.bcc_addr = ''
      this.form.status = true
      this.fetchDatabaseModel()
    },
    updateModel (model) {
      console.log(model)
      this.updateTargetId = model.id
      this.form = model
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('form-notis/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
  }
}
</script>

<style type="text/css">
.demo-block .source {
  padding: 24px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/noti-form/NotiForm.vue